import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { useCallback, useState } from "react";

const DismissCustomerMutation = graphql(`
  mutation DismissCustomer($input: DismissCustomerInput!) {
    dismissCustomer(input: $input) {
      clientId
      dismissedUntil
    }
  }
`);

export function useDismissCustomer() {
  const [result, _dismissCustomer] = useMutation(DismissCustomerMutation);
  const [error, setError] = useState<Error | null>(null);

  const dismissCustomer = useCallback(
    async (clientId: string, reason?: string, comment?: string) => {
      try {
        const response = await _dismissCustomer({
          input: { clientId, reason, comment },
        });

        if (response.error) {
          throw response.error;
        }

        if (!response.data || !response.data.dismissCustomer) {
          throw new Error("No data returned from dismissCustomer mutation");
        }

        setError(null);

        return {
          clientId: response.data.dismissCustomer.clientId,
          dismissedUntil: response.data.dismissCustomer.dismissedUntil,
        };
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [_dismissCustomer],
  );

  return { dismissCustomer, result, error };
}
